import React from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";

import {setAssignQuotePopupSearchText} from "./assignPopupFunctions";

const AssignQuotePopupSearch = (props) => {

  const {setAssignQuotePopupSearchText, assignQuotePopupSearchText, intl} = props;

  const handleSearchInputChange = (event) => {
    setAssignQuotePopupSearchText(event.target.value)
  };

  const searchText = assignQuotePopupSearchText;

  return (
    <div className="ui-search">
      <input type="text" className={"ui-search__input"
      + (searchText ? " ui-search__input--no-icon" : "")}
             value={searchText}
             onChange={handleSearchInputChange}
             placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
      />
      <span className="ui-search__icon"/>
      {searchText ? <button className={"ui-search__close"}
                            onClick={() => handleSearchInputChange({target:{value: ""}})}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  setAssignQuotePopupSearchText
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupSearch)
)
